import { render, staticRenderFns } from "./CreateNewRoleAccessModal.vue?vue&type=template&id=9a82389e"
import script from "./CreateNewRoleAccessModal.vue?vue&type=script&lang=js"
export * from "./CreateNewRoleAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports